export default __webpack_public_path__ + "media/643181a6bc16ca29a8c2e7d69846220ba71faf9e6bb49810b6bb0a6ccaf75c14.svg";